import {checkEmail, checkMobile, checkPhone} from '@/utils/validate'

export default {
  props: {
    isRequired: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    property: {
      immediate: true,
      handler(val) {
        if(this.extraRules) {
          // console.log('合并 rules')
          this.rules = Object.assign(this.rules, this.extraRules)
        }
      }
    }
  },
  data() {
    const checkRequired = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { field, message } = rule
      // const message = messageType == 'select'? this.$t('placeholder.select'): this.$t('placeholder.input')
      const messageResult = message || this.$t('placeholder.input')
      // 一個用於組件内，一個用於父組件
      const require = this.isRequired && this.requireValid
      if(require && !valueResult) {
        callback(new Error(messageResult))
      }
      if(this.baseField.includes(field) && !valueResult) {
        callback(new Error(messageResult))
      }
      callback()
    }
    return {
      requireValid: true,
      baseField: [
        'class_id',
        'trm_of_cvr',
        'brand_id',
        'typ_of_bdy_id',
        'engn_cpcty',
        'rgtn_yr',
        'ncd_pct',
        // 'usage_ind',
        'no_of_nm_drvr',
        'enough_age_ind',
        'enough_exp_ind',
        'dr_lic_of_own',
        'nm_drvr_exp',
        'nm_drvr_age',
        'nm_drvr_pt',
        'nm_drvr_acc',
        'model_id',
        // 'isrd_vl',
        'no_of_nm_drvr',
        'tonnage',
        'use_carrying_profit_ind',
        'alarm_or_global_ind',
        // 裝修工程
        'employee_ind',
        // 電單車
        'dr_nm_drvr_age',
        // 'no_acci_nor_deduct',
        'no_dr_acci_ind',
        'no_dr_deduct_ind',

      ], // 基礎報價資料
      ruleRequestData:{
        //car
        usage_ind:'',
        brand_id:'',
        typ_of_bdy_id:'',
        engn_cpcty:'',
        rgtn_yr:'',
        ncd_pct:'',
        model_id:'',
        tonnage:'',
        trm_of_cvr:'',
        no_of_nm_drvr:'',
        enough_age_ind:'',
        dr_nm_drvr_age: '',
        // no_acci_nor_deduct: '',
        no_dr_deduct_ind: '',
        no_dr_acci_ind: '',
        enough_exp_ind:'',
        dr_lic_of_own: '',
        nm_drvr_age: '',
        nm_drvr_exp: '',
        nm_drvr_acc: '',
        nm_drvr_pt: '',
        // isrd_vl:'',
        use_carrying_profit_ind:'',
        //housemale
        duty_id: '',
        nature: '',
        nationality_id: '',
        domestic_dob: '',
        period_of_cvr: '',
        monthly_salary: '',
        //decoration
        contr_prd: '',
        bldg_age: '',
        tol_contr_sum: '',
        mat_dam_cvr_ind: '',
        tp_lia_cvr_ind: '',
        outdoor_wk_ind: '',
        scaffolding_wk: '',
        employee_ind: '',
        //home&fire
        prop_insured: '',
        bldg_typ: '',
        floor_area: '',
        coverage_id: '',
        prop_age: '',
      },
      rules: {
        input: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        is_same_car: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        br_pic_path_id: [
          { required: false, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ],
        select: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        select_multiple: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['blur'] }
        ],
        upload: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['blur','change'] }
        ],
        class_id: [
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        usage_ind: [
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        no_acci_nor_deduct: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // {validator: checkRequired,  message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        no_dr_acci_ind: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // {validator: checkRequired,  message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        no_dr_deduct_ind: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // {validator: checkRequired,  message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        brand_id: [
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        rgtn_typ_of_bdy: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        engn_cpcty: [
          { validator: checkRequired, trigger: ['change', 'blur'] },
          { pattern:/^(0|\+?[1-9][0-9]{0,3})$/, message: '請輸入 0~9999 的整數',trigger: ['change', 'blur']  },

          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        rgtn_yr: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        ncd_pct: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        model_id: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        tonnage: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        typ_of_bdy_id:[
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        trm_of_cvr: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        no_of_nm_drvr: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        enough_age_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        dr_nm_drvr_age: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        enough_exp_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        dr_lic_of_own: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
        ],
        nm_drvr_exp: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
        ],
        nm_drvr_age: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        nm_drvr_pt: [
          { required: true, message: this.$t('placeholder.select'),  trigger: ['change', 'blur'] }
        ],
        nm_drvr_acc: [
          { required: true,  message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        isrd_vl: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        // 投保
        pcy_cmnt_dt: [
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        hp_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        mortgagor: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        mortgagor_other: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        prev_insurer_nm: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        prev_pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        pcy_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        prev_rgtn_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        car_camcorder_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        car_modified_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        alarm_or_global_ind: [
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: false, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        use_carrying_profit_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        engn_no: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        chasis_no: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        no_of_seats: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        business_purposes: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        rgtn_mdl: [
          { validator: checkRequired, trigger: ['change', 'blur'] },
          { pattern: /^[#a-zA-Z0-9][\w \&\'\(\)\,\.\-\+\_\/\|\*\#\%]{0,59}$/, message: '請輸入正確的格式' },
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        rgtn_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        isrd_lst_nm: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        isrd_fst_nm: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        isrd_title: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        isrd_dob: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        id_type: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        id_no: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        mobile_no: [
          { validator: checkMobile, trigger: ['blur'] },
          { validator: checkRequired, trigger: ['change', 'blur'] },
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        phone_no: [
          { validator: checkPhone, trigger: ['blur'] },
          { validator: checkRequired, trigger: ['change', 'blur'] },
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        guardian_phone: [
          { validator: checkPhone, trigger: ['blur'] },
          { validator: checkRequired, trigger: ['change', 'blur'] },
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        name: [
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
        ],
        phone: [
          { validator: checkPhone, trigger: ['blur'] },
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          // { pattern:/^[456789]\d{7}$/, message: '目前只支持中國香港的手機號碼' }

        ],
        email: [
          { required: false,  trigger: ['change', 'blur'] },
          { validator: checkEmail, trigger: ['change', 'blur'] },
          // { validator: checkRequired, trigger: ['change', 'blur'] },

          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        isrd_sex: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        occ_id: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        hldr_is_drvr_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        isrd_com_nm: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        contact_fst: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        contact_lst: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        bsns_nature_id: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        contact_nm: [
          { validator: checkRequired, trigger: ['change', 'blur'] },
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        contact_phone: [
          // { validator: checkRequired, trigger: ['change', 'blur'] },
          { required: true, message: this.$t('placeholder.input'), trigger: ['blur'] },
          { validator: checkMobile, trigger: ['blur'] },
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        contact_email: [
          { validator: checkEmail, trigger: ['blur'] },
          { required: true, message: this.$t('placeholder.input'), trigger: ['blur'] },
        ],
        contact_occ_id: [
          // { validator: checkRequired, trigger: ['change', 'blur'] },
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        addr_street: [
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        addr_district: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        addr_area: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        addr_region: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        // account
        identity: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        // ticket
        subject: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        customer_id: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        assignee_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        contact_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        preferred_time: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        action: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        money: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '請輸入正確的格式，可保留兩位小數' },
        ],
        card_holder: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        bank_code: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        card_number: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        accident_date: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        contact_person: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        description: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        isrd_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        amount: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        type: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        // new ticket

        // housemaid
        duty_id: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        age_limits: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        nature: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        nationality_id: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        domestic_age: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        domestic_dob: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        domestic_id_type: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        domestic_id_no: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        period_of_cvr: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        monthly_salary: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        domestic_title: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        domestic_lst_nm: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: false, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        domestic_fst_nm: [
          // { validator: checkRequired, trigger: ['change', 'blur'] }
          { required: false, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        full_name: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_type_pic_path_id: [
          { required: false, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
        domestic_id_type_pic_path_id: [
          { required: false, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
        cert_of_inc_pic_path_id: [
          { required: false, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
        renew_file_path_id: [
          { required: false, message: this.$t('placeholder.upload'), trigger: ['blur','change'] }
        ],
        // Overseas Student
        country_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        accompanying_dob: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        accompanying_rel: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        accompanying_id_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        accompanying_title: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        accompanying_fst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        accompanying_lst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        student_dob: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        student_title: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        student_rel: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        student_lst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        student_fst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        student_id_type: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        student_id_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        student_ins_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        student_addr: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        accompanying_id_type: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        is_full_time: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        hldr_is_student_ind: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        // travel
        plan_type: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        pcy_expry_dt: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        class_type: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        no_of_adult: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        no_of_traveler: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        area_of_travel: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        dob: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        // benefits: [
        //   { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        // ],
        // working
        destination_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        // home fire
        is_same_as_corr_addr: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        prop_insured: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        bldg_typ: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        floor_area: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        coverage_id: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        prop_age: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        owner_liability_ind: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        bsc_sum_insured: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        phone_mdl_1: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        // decoration
        contr_prd: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        bldg_age: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        tol_contr_sum: [
          { validator: checkRequired, trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        mat_dam_cvr_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        tp_lia_cvr_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        outdoor_wk_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        employee_ind: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        scaffolding_wk: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        occupied_as: [
          { validator: checkRequired, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
          // { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        con_nm: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        con_phone_no: [
          { validator: checkPhone, trigger: ['blur'] },
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },

        ],
        contract_path_id: [
          { required: false, message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] }
        ],
        sum_insured: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        ci_no:[
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],

        // reply
        loading_base_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_china_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_claim_exp_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_drvr_age_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_drvr_exp_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_veh_age_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_occupation_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_nm_drvr_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_others_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],

        quote_status: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        company_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        plan_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        code_disc_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        base_prm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        basic_prm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        ia_levy_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        ec_levy_vl: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        ia_levy_vl: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        coupon_vl: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        spec_disc_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        handling_fee: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        additional_charge: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        srd_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        loading_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        cfd_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        mib_pct: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        sum_building:[
          // { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '請輸入正確格式，可保留兩位小數' },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        no_of_rooms:[
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        sum_content:[
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },

          // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '請輸入正確格式，可保留兩位小數' },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },        ],
        sum_stock:[
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '請輸入正確格式，可保留兩位小數' },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },        ],
        no_of_employee:[
          { required: false, trigger: ['change', 'blur']},
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能输入正整数' },
        ],
        total_contract_vl:[
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '請輸入正確格式，可保留兩位小數' },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },        ],
        contract_vl:[
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          // { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '請輸入正確格式，可保留兩位小數' },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },        ],
        no_of_spouse:[
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        no_of_kid:[
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        no_of_older:[
          { required: false, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        student_age:[
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          {  pattern: /^[0-9]*[1-9][0-9]*$/, message: '只能輸入正整數' },
        ],
        val_email:[
          { required: false, trigger: ['change', 'blur'] },
          { validator: checkEmail, trigger: ['blur'] }
          // { pattern:/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ , message: '請輸入正確的郵箱',trigger: ['change', 'blur']  },
          // {  type: 'number', message: '只能输入数字' },
        ],
        start_time: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        end_time: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        thumb_url: [
          { required: true, message: this.$t('placeholder.upload'), trigger: ['blur'] }
        ],
        url: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        product_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],

        // premium
        mat_dam_prm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        tppd_limit_prm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        ec_levy_prm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        spec_disc_prm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        valid_phone: [
          { validator: checkPhone, trigger: ['blur'] }
        ],
        valid_mobile: [
          { validator: checkMobile, trigger: ['blur'] }
        ],
        valid_email: [
          { validator: checkEmail, trigger: ['blur'] }
        ],
        coupon_code:[
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] },
          {  pattern: /^[A-Z0-9]+$/, message: '只能輸入大寫字母及數字' },
          // {  pattern: /^(?![0-9]+$)(?![A-Z]+$)[0-9A-Z]+$/, message: '只能輸入大寫字母及數字' },
        ],
        description_hk:[
          { required: true, message: this.$t('placeholder.input'),ger: ['change', 'blur'] }
        ],
        description_en: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        title_hk: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        title_en: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        amount_type: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        applies_to_type: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        is_new_customer: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        coupon_date:[
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }

        ],
        content:[
          { required: true, message: this.$t('placeholder.input'), trigger: ['blur'] }
        ],
        pay_type:[
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        transaction_date:[
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        age_id:[
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],

        cvr_nt_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        //catering sme rules
        bus_nature: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        bus_hour_24: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        fl_area_of_seat: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        fl_area_of_work: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        cook_with_fire_ind: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        claim_history_ind: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        reject_ind: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        stocks_ind: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        stocks_isrd: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        self_employed_ind: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        // occ_id: [
        //   { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        // ],
        nature_time: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        nature_time_enable: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
        annual_salary: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change','blur'] }
        ],
      }
    }
  }
}
